import styled from "styled-components"
import MobileLayout from "../../layout"
import { listResumeUser } from "@/http/api"
import moment from "moment"
import { useEffect, useState } from "react"
import UserResumeItem from "../Home/components/UserResumeItem"
import { InfiniteScroll } from "antd-mobile"
import NavigationHeader from "@/pages/Mobile/components/NaviGationHeader/index.js"

const MyStyled = styled.div`
    background-color: rgba(247, 248, 249, 1);
    padding: 15px;
    min-height: 100vh;
    box-sizing: border-box;
    .my-title {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        margin-bottom: 15px;
    }
`

const List = () => {
    const [mutation, setMutation] = useState(0)
    const [hasMore, setHasMore] = useState(true)
    const [dataList, setDataList] = useState([])
    const [current, setCurrent] = useState(1)
    const [loading, setLoading] = useState(false)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        if (mutation > 0) {
            setCurrent(1) 
            setDataList([])
            setHasMore(true)
        }
    }, [mutation])

    const fetchList = async () => {
        if (loading) return 
        setLoading(true)
        const res = await listResumeUser({
            query: {
                page: current,
                pageSize: 6
            }
        });
        const dataList = res?.dataList?.map((item) => {
            let data = JSON.parse(item.pagesData?.[0]?.userData);;
            return {
                data,
                resume: {
                    id: item.id, resumeId: item.id,
                },
                resumeData: data,
                name: item.name,
                updateTime: moment(item.updateTime).format("YYYY-MM-DD HH:mm"),
                id: item.id
            }
        });
        if (dataList) {
            setCurrent(current => current + 1)
            setDataList((list) => [...list, ...dataList])
            setHasMore(dataList.length > 0)
        } else {
            setHasMore(false)
        }
        setTotal(res?.count || 0)
        setLoading(false)
    }

    const handleMutation = () => {
        setMutation(m => m + 1)
    }

    return  <MyStyled>
        <NavigationHeader title={document.title} style={{left:'-15px',top:'-15px',width:'100vw'}}></NavigationHeader>
        <div className="my-title">在线简历（{total}）</div>
        <div className="my-wrap">
            {dataList.map(item => {
                return <UserResumeItem 
                    key={item.id} 
                    id={item.id} 
                    title={item.name} 
                    
                    time={item.updateTime}
                    style={{ marginBottom: 15 }}
                    onMutation={handleMutation}
                />
            })}
        </div>
        <InfiniteScroll loadMore={fetchList} hasMore={hasMore} />
    </MyStyled>
}

export default List